import * as yup from 'yup';

export const emailRequired = (requiredMessage?: string) =>
  yup
    .string()
    .required(requiredMessage || 'E-mail не указан')
    .matches(/\S+@\S+\.\S+/, 'E-mail указан неверно');

const requiredString = (requiredMessage?: string) => yup.string().required(requiredMessage);
const optionalString = yup.string().optional();
const optionalBoolean = yup.boolean().optional();
const number = yup.number().transform((value) => (Number.isNaN(value) ? undefined : value));

const optionalNumber = number.optional();
const requiredNumber = (requiredMessage?: string) => number.positive().required(requiredMessage);
const optionalArrayOfNumbers = (requiredMessage?: string) =>
  yup.array().of(requiredNumber(requiredMessage)).optional();
const requiredArrayOfNumbers = (requiredMessage?: string) =>
  yup
    .array()
    .of(requiredNumber(requiredMessage))
    .test({ message: requiredMessage, test: (arr) => arr && arr.length > 0 })
    .required(requiredMessage);
const cost = {
  cost: yup
    .number()
    .positive()
    .nullable()
    .required()
    // .min(0)
    .max(99999999999999),
  // .test(
  // 	'noEOrSign', // type of the validator (should be unique)
  // 	'Number had an \'e\' or sign.', // error message
  // 	(value) => !/[eE+-]/.test(value.toString()),
  // ),
};

const formWithVideo = {
  isNewVideo: optionalBoolean,
  video_type: yup.string().oneOf(['B', 'Y', 'R', 'V', 'O']).optional(),
  url: optionalString,
  file: yup.mixed().optional(),
};
const group_costs = yup
  .array()
  .of(yup.object({ entityId: yup.number().required(), ...cost }))
  .optional();

const requiredEditor = yup
  .string()
  .required()
  .test((value) => {
    const el = document.createElement('section');
    el.innerHTML = value;
    return Boolean(el.getElementsByTagName('img').length || el.innerText.trim());
  });

export const CreateAndEditScheduleServiceSchema = yup.object({
  title: requiredString(),
  description: optionalString,
  photo: optionalString,
  video: optionalNumber,
  duration: optionalNumber,
  ...cost,
  group_costs: group_costs,
  group_costsEditor: group_costs,

  isNewVideo: optionalBoolean,
  file: yup.mixed().optional(),
  url: optionalString,
  video_type: optionalString,
});

export const CreateAndEditScheduleAddressSchema = yup.object({
  city: requiredString(),
  // city: optionalString,
  street: optionalString,
  house: optionalString,
  apartment: optionalString,
  note: optionalString,
});

export const CreateAndEditScheduleTermSchema = yup.object({
  cost_payment_method: yup.mixed<'C' | 'O'>().oneOf(['O', 'C']).optional(),
  status: yup.mixed<'ON' | 'OF'>().oneOf(['ON', 'OF']).optional(),
  prepayment: requiredNumber('Укажите предоплату'),
  cancel: optionalNumber,
  termination_of_registration: optionalNumber,
  // online_meeting_service: optionalNumber,
  coach: optionalNumber,
  note: optionalString,
  address: optionalNumber,
  contacts: optionalArrayOfNumbers(),
  services: requiredArrayOfNumbers('Добавьте услугу'),
});

export const CreateAndEditArticle: any = yup.object({
  content: requiredEditor,
  cover: requiredString(),
  description: optionalString,
  module: yup.number().optional(),
  tags: optionalArrayOfNumbers(),
  title: requiredString(),
  access_duration: yup.number().optional(),
  with_comments: yup.boolean().optional(),
  with_likes: yup.boolean().optional(),
});

export const EditCoachProfile = yup.object({
  first_name: requiredString(),
  middle_name: optionalString,
  last_name: requiredString(),
  photo: optionalString,
  description: optionalString,
  active_contacts: optionalArrayOfNumbers(),
  tags: optionalArrayOfNumbers(),
  module: optionalNumber,
  ...formWithVideo,
});
